export const links = {
  twitter:"https://www.twitter.com/griceviz",
  facebook:"https://www.facebook.com/griceviz/",
  instagram:"https://www.instagram.com/griceviz/",
  halici:"https://www.halici.com.tr",
  ios:"https://itunes.apple.com/tr/app/griceviz/id1240173390",
  android:"https://play.google.com/store/apps/details?id=tr.com.halici.brainquiremobile",
  griceviz:"https://brainquire.com/tr/"
}
